import HealthCareLearnMore from "../../Medical/LearnMore/HealthCareLearnMore";
import LearnMoreModal from "../../Medical/LearnMore/LearnMoreModal";
import ManagingMedicationsLearnMore from "../../Medical/LearnMore/ManagingMedicationsLearnMore";
import MonitoringChangesLearnMore from "../../Medical/LearnMore/MonitoringChangesLearnMore";
import ComingSoonPlaceholder from "../../../../Assessment/ComingSoonPlaceholder";
import EvaluateDrivingLearnMore from "../../Medical/LearnMore/EvaluateDrivingLearnMore";
import PlanWithGCMLearnMore from "../../Medical/LearnMore/PlanWithGCMLearnMore";
import ExerciseAndActivityLearnMore from "../../Medical/LearnMore/ExerciseAndActivityLearnMore";
import AssessFacilityQualityLearnMore from "../../Medical/LearnMore/AssessFacilityQualityLearnMore";
import CognitiveImpairmentLearnMore from "../../Medical/LearnMore/CognitiveImpairmentLearnMore";
import CommunityServicesLearnMore from "../../Medical/LearnMore/CommunityServicesLearnMore";

export interface MedicalLearnMoreFactoryProps {
  infoSlideIndex: number;
}

export const MedicalLearnMoreFactory: React.FC< MedicalLearnMoreFactoryProps> 
= ({ infoSlideIndex }) => {
  switch (infoSlideIndex) {
    case 0: {
      return (
        <LearnMoreModal learnMoreTitle={"Comprehensive Geriatric Medical Assessment"} />       
      );
    }
    case 1: {
      return (
        <MonitoringChangesLearnMore />
      );
    }
    case 2: {
      return (
        <HealthCareLearnMore />
      );
    }
    case 3: {
      return (
        <ManagingMedicationsLearnMore />
      );
    }
    case 4: {
      return (
        <EvaluateDrivingLearnMore />
      );
    }
    case 5: {
      return (
        <PlanWithGCMLearnMore />
      );
    }
    case 6: {
      return (
        <AssessFacilityQualityLearnMore />
      );
    }
    case 7: {
      return (
        <ExerciseAndActivityLearnMore />
      );
    }
    case 8: {
      return (
        <CognitiveImpairmentLearnMore />
      );
    }
    case 9: {
      return (
        <CommunityServicesLearnMore />
      );
    }
    default: {
      return (
        <ComingSoonPlaceholder />
      );
    }
  };
};
